import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { Ion } from 'cesium';

// Cesium Ion のアクセストークンを空文字に設定
Ion.defaultAccessToken = '';
// import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  // <React.StrictMode>
    <div className="">
      <App />
    </div>
  // </React.StrictMode>
  ,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// reportWebVitals();
